import React, { useState, useEffect, useCallback } from "react";
import InitialLoader from "components/InitilalLoader";
import MainComponent from "components/MainComponent";
import "../Subscription/Subscription.scss";
import "./Proposal.scss";
import { GrFormClose } from "react-icons/gr";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import DisplayData from "./DisplayData";
import StandardStatements from "./StandardStatments";
import { useNavigate } from "react-router-dom";
import { useStandardStatements } from "./hooks/useStandardStatements";
import { useAutoText } from "./hooks/useAutoText";
import { useUpdateStandardStatements } from "./hooks/useUpdateStandardStatements";
import { useStaticAll } from "./hooks/useStaticAll";
import { HeaderText } from "./helper/const";
import Spinner from "components/common/spinner/spinner";

const ProposalText = () => {
  const [statementId, setStatementId] = useState("");
  const [statementsCategory, setStatementsCategory] = useState([]);
  const [per, setPer] = useState(0);
  const [percentageModal, setPercentageModal] = useState(false);
  const [percentage, setPercent] = useState(per);
  const [displayText, setDisplayText] = useState("");
  const [percentageStatementIdx, setPercentageStatementIdx] = useState("");
  const [textId, setTextId] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  const navigate = useNavigate();

  // TanStack Query hooks
  const {
    data: staticAllData,
    error: staticAllError,
    isLoading: staticAllLoading,
  } = useStaticAll();
  const {
    data: standardStatementsData,
    error: standardStatementsError,
    isLoading: standardStatementsLoading,
    refetch: standardStatementsRefetch,
  } = useStandardStatements();

  const {
    data: autoTextsData,
    error: autoTextsError,
    isLoading: autoTextsLoading,
    refetch: autoTextsRefetch,
  } = useAutoText(
    statementId,
    !!statementId &&
      statementsCategory.length > 0 &&
      statementId !== statementsCategory[0]?.dropId
  );
  console.log("standardStatementsData", {
    standardStatementsData,
    staticAllData,
    autoTextsData,
    statementId,
    statementsCategory,
  });

  const { mutate: UpdateStandardStatementMutation, isPendingUpdate } = useUpdateStandardStatements();

  useEffect(() => {
    if (staticAllData && staticAllData.autoTextDropDown) {
      setStatementsCategory(staticAllData.autoTextDropDown);
    }
  }, [staticAllData]);

  useEffect(() => {
    if (staticAllError) toast.error(staticAllError.message);
  }, [staticAllError]);
  useEffect(() => {
    if (standardStatementsError) toast.error(standardStatementsError.message);
  }, [standardStatementsError]);
  useEffect(() => {
    if (autoTextsError)
      toast.error("Unable to get the selected drop down's data");
  }, [autoTextsError]);

  const changePer = (value) => setPer(value);
  const changePerData = (increase = true) => {
    let newPer = percentage;
    if (increase) {
      newPer += 1;
    } else {
      newPer -= 1;
    }
    setPercent(newPer < 0 ? 0 : newPer);
  };

  const applyPercentageChanges = () => {
    changePer(percentage);
    let postData = {
      isSelected: isSelected === undefined ? isSelected : isSelected,
      displayText,
      percentage,
    };
    UpdateStandardStatementMutation(
      { textId, postData },
      {
        onSuccess: () => {
          toast.success("Successfully updated the statement.");
        },
        onError: (err) => toast.error(err.message),
      }
    );
    hidePercentageStepperModal();
  };

  console.log("textId", textId);
  const showPercentageStepperModal = (displaytext, idx) => {
    setPercent(displaytext.percentage);
    setDisplayText(displaytext.displayText);
    setIsSelected(displaytext.isSelected);

    setTextId(displaytext._id);
    setPercentageModal(true);
    const idd = standardStatementsData.findIndex(
      (list) => list._id === displaytext._id
    );

    console.log("displaytextaa", displaytext);
    console.log("idd", idd);
    setPercentageStatementIdx(idd);
  };

  const hidePercentageStepperModal = () => {
    setPercentageModal(false);
  };

  const cancelChanges = () => {
    setPercent(per);
    hidePercentageStepperModal();
  };

  const switchDropdownBody = () => {
    if (
      staticAllLoading ||
      standardStatementsLoading ||
      autoTextsLoading ||
      autoTextsError ||
      standardStatementsError
    ) {
      return <Spinner centerViewport size="lg" />;
    }
    if (!statementId) return null;
    if (statementId === "Standard Statements") {
      return (
        <StandardStatements
          data={standardStatementsData}
          showPercentageStepperModal={showPercentageStepperModal}
        />
      );
    }
    return <DisplayData autoTextsData={autoTextsData} />;
  };

  return (
    <>
      <MainComponent>
        <div className="_container_right _user_page">
          <div className="__proposal">
            <Row>
              <Col>
                <div dangerouslySetInnerHTML={{ __html: HeaderText }} />
              </Col>
            </Row>
            <Row style={{ marginTop: "2em", marginBottom: "2em" }}>
              <Col lg="3">
                <Form.Group>
                  <Form.Label>Select Statement Category</Form.Label>
                  <Form.Control
                    as="select"
                    value={statementId}
                    onChange={(e) => setStatementId(e.target.value)}
                  >
                    <option value="">Select...</option>
                    {statementsCategory.length > 0 &&
                      statementsCategory.map((statement) => (
                        <option
                          key={statement.dropName}
                          value={statement.dropName}
                        >
                          {statement.dropName}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            {statementsCategory.length > 0 && switchDropdownBody()}
          </div>
        </div>
      </MainComponent>

      <Modal
        show={percentageModal}
        onHide={hidePercentageStepperModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{displayText.replace(":", "")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="justify-content-center align-items-center mx-2 font-weight-bold row">
            <div className="justify-content-end d-flex col-lg-3">
              <Button
                variant="outline-dark"
                onClick={() => changePerData(false)}
                style={{ width: "4em", height: "2.5em" }}
              >
                -
              </Button>
            </div>
            <div className="col-lg-3">
              <Form.Control
                type="text"
                value={percentage}
                disabled
                style={{ textAlign: "center", height: "100%" }}
              />
            </div>
            <div className="col-lg-3">
              <Button
                variant="outline-dark"
                onClick={() => changePerData()}
                style={{ width: "4em", height: "2.5em" }}
              >
                +
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={cancelChanges}>
            Cancel
          </Button>
          <Button variant="primary" onClick={applyPercentageChanges}>
            Apply
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProposalText;
